var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 104 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4,29 C60.2,28.7 60.1,28.3 60.1,27.8 C58.7,12.3 46,0.6 30.4,0.6 C13.9,0.6 0.5,14 0.5,30.4 C0.5,40 4.9,49.5 12.4,55.8 C12.6,56 12.9,56.3 12.9,56.8 L12.9,72.6 C12.9,75 14.7,77 17.2,77.3 L40.9,79.4 C41,79.4 41.2,79.4 41.3,79.4 C42.5,79.4 43.6,79 44.5,78.2 C45.5,77.3 46,76.1 46,74.8 L46,64.5 L53.4,64.5 C57.2,64.5 60.3,61.4 60.3,57.6 L60.3,47.9 L63,47.9 C65,47.9 66.8,46.8 67.7,45.1 C68.6,43.4 68.5,41.3 67.5,39.6 L60.4,29 Z M63.6,42.9 C63.5,43.1 63.3,43.3 62.9,43.3 L58.9,43.3 C57.2,43.3 55.7,44.7 55.7,46.5 L55.7,57.6 C55.7,58.9 54.6,60 53.3,60 L45,60 C43,60 41.4,61.6 41.4,63.6 L41.2,74.9 L17.4,72.7 L17.4,56.8 C17.4,55.1 16.6,53.5 15.3,52.4 C9,47 5,38.6 5,30.4 C5,16.4 16.4,5.1 30.3,5.1 C43.5,5.1 54.3,15 55.5,28.2 C55.6,29.3 55.9,30.3 56.5,31.3 L63.5,42 C63.8,42.4 63.7,42.7 63.6,42.9 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7,35.9 C87.9,34.9 86.4,34.8 85.5,35.6 L85.3,35.8 C84.4,36.6 84.3,38 85,39 C88.5,43.3 90.7,48.8 90.7,54.7 C90.7,60.7 88.6,66.1 85,70.4 C84.2,71.4 84.3,72.8 85.3,73.6 L85.5,73.8 C86.5,74.6 87.9,74.5 88.7,73.5 C92.9,68.4 95.5,61.8 95.5,54.7 C95.5,47.5 93,41 88.7,35.9 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4,41.3 C81.6,40.3 80.1,40.2 79.2,41 L79.1,41.1 C78.2,41.9 78,43.3 78.8,44.2 C81.1,47 82.5,50.7 82.5,54.6 C82.5,58.6 81.1,62.2 78.8,65 C78,65.9 78.2,67.3 79.1,68.1 L79.2,68.2 C80.2,69 81.6,68.9 82.4,67.9 C85.4,64.2 87.2,59.6 87.2,54.5 C87.2,49.6 85.4,44.9 82.4,41.3 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1,46.7 C75.3,45.7 73.8,45.6 72.9,46.4 C72,47.2 71.9,48.6 72.6,49.5 C73.7,50.9 74.4,52.7 74.4,54.6 C74.4,56.5 73.7,58.3 72.6,59.7 C71.9,60.7 72,62 72.9,62.8 C73.9,63.6 75.4,63.5 76.1,62.5 C77.8,60.3 78.8,57.5 78.8,54.5 C78.9,51.7 77.9,48.9 76.1,46.7 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceOn);
export default __webpack_public_path__ + "static/media/voiceOn.52b55481791fda19e854f3f5d505267d.svg";
export { ForwardRef as ReactComponent };